import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Empty, notification, Spin } from "antd";
import { httpService } from "../../base/services/httpService.service";
import Banner from "./Banner";
import TicketSummary from "./TicketSummary";
import ChatCard from "./ChatCard";

import "./Tickets.scss";

export const formatDateString = (dateString) => {
   const date = new Date(dateString.endsWith("Z") ? dateString : dateString + "Z");

   const day = date
      .getDate()
      .toString()
      .padStart(2, "0");
   const month = date.toLocaleString("default", { month: "short" });
   const year = date.getFullYear();

   const hours = date
      .getHours()
      .toString()
      .padStart(2, "0");
   const minutes = date
      .getMinutes()
      .toString()
      .padStart(2, "0");

   return `${day}-${month}-${year} ${hours}:${minutes}`;
};

const TicketPreview = () => {
   const navigate = useNavigate();
   const [ticketDetails, setTicketDetails] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const { id } = useParams();

   const fetchData = useCallback(() => {
      setIsLoading(true);

      try {
         const params = new URLSearchParams({
            id
         });
         httpService.get(
            `/Tickets/getTicketById?${params.toString()}`,
            (response) => {
               const data = {
                  ...response.data,
                  createdAt: formatDateString(response.data.createdAt)
               };
               setTicketDetails(data);
               setIsLoading(false);
            },
            (_err) => {
               notification.error({
                  message: "Something went wrong, please try again later."
               });
               setIsLoading(false);
            }
         );
      } catch (error) {
         setIsLoading(false);
         notification.error({
            message: "Something went wrong, please try again later."
         });
      }
   }, [id]);

   useEffect(() => {
      fetchData();
   }, [fetchData]);

   const ticketProps = useMemo(
      () => ({
         organizationName: ticketDetails?.organizationName,
         createdAt: ticketDetails?.createdAt,
         submittedBy: ticketDetails?.submittedBy,
         type: ticketDetails?.type,
         subject: ticketDetails?.subject,
         message: ticketDetails?.lastResponse,
         attachments: ticketDetails?.attachments
      }),
      [
         ticketDetails?.attachments,
         ticketDetails?.createdAt,
         ticketDetails?.lastResponse,
         ticketDetails?.organizationName,
         ticketDetails?.subject,
         ticketDetails?.submittedBy,
         ticketDetails?.type
      ]
   );

   return (
      <div className="ticket-preview">
         <Banner />

         {isLoading ? (
            <Spin
               style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "50px",
                  width: "100%"
               }}
            />
         ) : (
            <>
               {" "}
               <div className="ticket-preview__content">
                  {ticketDetails ? (
                     <>
                        <div className="ticket-preview__header">
                           <Button
                              type="link"
                              className="ticket-preview__back"
                              onClick={() => navigate("/tickets")}
                           >
                              ← Go back to ticket history list
                           </Button>
                        </div>
                        <div className="ticket-preview__body d-md-flex" style={{ gap: "20px" }}>
                           <TicketSummary {...ticketProps} />
                           <ChatCard {...ticketProps} />
                        </div>
                     </>
                  ) : (
                     <Empty
                        style={{
                           padding: "50px 0"
                        }}
                     />
                  )}
               </div>
            </>
         )}
      </div>
   );
};

export default TicketPreview;
